import React from 'react'
import { Outlet } from 'react-router-dom'
import Logo from '@/assets/icon-white.png'
import { Column, Flex } from '@/components/core'
import StepIndicator from '@/components/step-indicator'

type PageLayoutProps = {
  children?: React.ReactNode | React.ReactNode[]
}

const PageLayout: React.FC<PageLayoutProps> = () => {
  return (
    <Column className="min-h-screen w-full items-center justify-center">
      <Flex className="box-border h-screen w-full max-w-[1115px] flex-col justify-center">
        <Flex className="h-full w-full flex-row overflow-hidden bg-electric-indigo-900/30 max-lg:flex-col lg:rounded-2xl lg:shadow xl:max-h-[95%]">
          <>
            <Column className="relative w-full max-w-[244px] justify-between gap-y-8 bg-electric-indigo-900/20 pb-[52px] pl-[40px] pr-[52px] pt-[72px] max-lg:hidden">
              <img src={Logo} alt="FluencyFlow" width={56} height={56} />
              <StepIndicator />
              <span className="text-xs text-electric-indigo-50/50">
                FluencyFlow © Copyright
              </span>
            </Column>
            <Column className="w-full p-4 lg:hidden">
              <StepIndicator />
            </Column>
          </>
          <Column className="h-full w-full items-center justify-center">
            <Outlet />
          </Column>
        </Flex>
      </Flex>
    </Column>
  )
}

export default PageLayout
